import React from 'react';
import { Box, Stack } from '@mui/material';

// MyAccount.js's dashboard menu: only ONE section renders at a time (the
// page used to stack Personal Info/Household/Seats/Invoices/Statement in
// one long scroll) — this switches between them instead of scrolling to
// an anchor. Renders as a real left-column sidebar on desktop and a
// horizontally scrollable tab row on mobile, where a sidebar wouldn't fit
// next to the content column.
const itemSx = (active) => ({
  border: 'none',
  background: active ? 'rgba(15,117,188,0.08)' : 'none',
  cursor: 'pointer',
  textAlign: 'left',
  fontFamily: 'var(--font-body)',
  fontWeight: 700,
  fontSize: 13,
  letterSpacing: '0.04em',
  color: active ? 'var(--teal-500)' : 'var(--navy-500)',
  opacity: active ? 1 : 0.65,
  transition: 'opacity 150ms ease, background 150ms ease',
  '&:hover': { opacity: 1 },
});

export default function AccountNav({ items, activeId, onSelect }) {
  return (
    <>
      {/* Desktop: sticky left sidebar */}
      <Box
        component="nav"
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'sticky',
          top: 24,
          width: 220,
          flexShrink: 0,
        }}
      >
        <Stack spacing={0.5}>
          {items.map((item) => (
            <Box
              key={item.id}
              component="button"
              type="button"
              onClick={() => onSelect(item.id)}
              sx={{ ...itemSx(item.id === activeId), px: 2, py: 1.4, borderRadius: 1 }}
            >
              {item.label}
            </Box>
          ))}
        </Stack>
      </Box>

      {/* Mobile: horizontally scrollable tab row */}
      <Box
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'sticky',
          top: 0,
          zIndex: 5,
          background: 'var(--paper)',
          borderBottom: '1px solid rgba(36,34,88,0.12)',
          mx: { xs: -2.5, sm: -4 },
          px: { xs: 2.5, sm: 4 },
          mb: 3,
        }}
      >
        <Stack
          direction="row"
          spacing={2.5}
          sx={{ overflowX: 'auto', py: 1.5, '&::-webkit-scrollbar': { display: 'none' } }}
        >
          {items.map((item) => (
            <Box
              key={item.id}
              component="button"
              type="button"
              onClick={() => onSelect(item.id)}
              sx={{
                ...itemSx(item.id === activeId),
                flexShrink: 0,
                fontSize: 12,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                px: 0.5,
                py: 0.5,
              }}
            >
              {item.label}
            </Box>
          ))}
        </Stack>
      </Box>
    </>
  );
}
